import { defineMessages, MessageDescriptor } from 'react-intl'

export type Bank = 'Swedbank' | 'Handelsbanken' | 'SEB' | 'Sparbanken' | 'Nordea' | 'Länsförsäkringar'
export type BankId =
  | 'swedbankCompany'
  | 'handelsbankenCompany'
  | 'sebCompany'
  | 'sparbankenCompany'
  | 'nordea'
  | 'lfBank'

export const companyBanks: { [bankId: string]: Bank } = {
  swedbankCompany: 'Swedbank',
  sparbankenCompany: 'Sparbanken',
  sebCompany: 'SEB',
  handelsbankenCompany: 'Handelsbanken',
  nordea: 'Nordea',
  lfBank: 'Länsförsäkringar',
}

const companyBranchesMessages = defineMessages({
  branchBuilding: {
    id: 'component.functional.contact-form.options.company-branch.building',
    defaultMessage: 'Bygg',
  },
  branchTechnology: {
    id: 'component.functional.contact-form.options.company-branch.technology',
    defaultMessage: 'Data och IT',
  },
  branchRetail: {
    id: 'component.functional.contact-form.options.company-branch.retail',
    defaultMessage: 'Detaljhandel',
  },
  branchMarketing: {
    id: 'component.functional.contact-form.options.company-branch.marketing',
    defaultMessage: 'Marknadsföring och reklam',
  },
  branchBusinessDevelopment: {
    id: 'component.functional.contact-form.options.company-branch.business-development',
    defaultMessage: 'Affärsutveckling',
  },
  branchHotel: {
    id: 'component.functional.contact-form.options.company-branch.hotel',
    defaultMessage: 'Hotell och restaurang',
  },
  branchEconomy: {
    id: 'component.functional.contact-form.options.company-branch.economy',
    defaultMessage: 'Juridik och Ekonomi',
  },
  branchHealth: {
    id: 'component.functional.contact-form.options.company-branch.health',
    defaultMessage: 'Hälsa och Sjukvård',
  },
  branchRealEstate: {
    id: 'component.functional.contact-form.options.company-branch.realEstate',
    defaultMessage: 'Fastigheter',
  },
  branchTransport: {
    id: 'component.functional.contact-form.options.company-branch.transport',
    defaultMessage: 'Transport',
  },
  branchOther: {
    id: 'component.functional.contact-form.options.company-branch.other',
    defaultMessage: 'Annat',
  },
})

export const companyBranches: { [branchId: string]: MessageDescriptor } = {
  building: companyBranchesMessages.branchBuilding,
  technology: companyBranchesMessages.branchTechnology,
  marketing: companyBranchesMessages.branchMarketing,
  businessDevelopment: companyBranchesMessages.branchBusinessDevelopment,
  retail: companyBranchesMessages.branchRetail,
  hotel: companyBranchesMessages.branchHotel,
  economy: companyBranchesMessages.branchEconomy,
  health: companyBranchesMessages.branchHealth,
  realEstate: companyBranchesMessages.branchRealEstate,
  transport: companyBranchesMessages.branchTransport,
  other: companyBranchesMessages.branchOther,
}

export const unsupportedCompanyBranches: { [branchId: string]: MessageDescriptor } = {
  building: companyBranchesMessages.branchBuilding,
  retail: companyBranchesMessages.branchRetail,
  hotel: companyBranchesMessages.branchHotel,
  health: companyBranchesMessages.branchHealth,
  realEstate: companyBranchesMessages.branchRealEstate,
  transport: companyBranchesMessages.branchTransport,
  other: companyBranchesMessages.branchOther,
}

export const ratsitCompanyCodesToDooerCompanyCodes: { [key: string]: string } = {
  LimitedCompany: 'AB',
  SoleProprietorship: 'EF',
  TradingCompanyLimitedPartnerShip: 'HB',
  others: 'OTHER',
}

export const companyRevenueToRevenueRange = (value: string) => {
  const ONE_MILLION = 10 ** 6
  const HUNDRED_MILLION = ONE_MILLION * 100

  // For example:
  // '0-1' -> [0, 1000000] // [0, 1 million]
  // '2' -> [2000000, 100000000] // [2 million, 100 million]
  // using 100 million to indicate no limit
  return value
    ? value.includes('-')
      ? [Number(value.split('-')[0]) * ONE_MILLION, Number(value.split('-')[1]) * ONE_MILLION]
      : [Number(value) * ONE_MILLION, HUNDRED_MILLION]
    : null
}

export const hideSecretsInPersonalNumber = (value: string) => {
  const DEFAULT_SWEDISH_ID_NUMBER_LENGTH = 10
  const SWEDISH_ID_NUMBER_SECRETS_LENGTH = 4

  if (!value) {
    return value
  } else if (value.length < DEFAULT_SWEDISH_ID_NUMBER_LENGTH) {
    return value
  }

  const trimmedValue = value.length === 15 && value.endsWith('00001') ? value.replace('00001', '') : value
  const publicPart = value.slice(0, trimmedValue.length - SWEDISH_ID_NUMBER_SECRETS_LENGTH)

  return publicPart + 'XXXX'
}
